import api from './axiosInstance';

export const workerRateApi = {
  listByWorker: workerId =>
    api.get('/worker-rate-rules', {params: {workerId}}),

  batchSave: (workerId, items) =>
    api.post(`/worker-rate-rules/batch?workerId=${workerId}`, {items}),

  resolve: (workerId, catalogItemId, serviceCatalogItemId) =>
    api.get('/worker-rate-rules/resolve', {
      params: {workerId, catalogItemId, serviceCatalogItemId},
    }),
};
